import React, {Component} from "react";
import { BrowserRouter, Route } from "react-router-dom";
import './Home.css'
import Sidebare from "./Sidebare";
import NouveauEtudiant from "./NouveauEtudiant";
import ListeEtudiants from "./ListeEtudiants";
import Recherche from "./Recherche";
import ModifierEtudiant from "./ModifierEtudiant";
import GererUtilisateurs from "./GererUtilisateurs";
import Reinscription from "./Reinscription";
import TransfertEtudiant from "./TransfertEtudiant";
import CertificatScolarite from "./CertificatScolarite";
import Absence from "./Absence";

class Home extends Component {
	state = {
		user: {}
	}

    render() {
        return(
            <BrowserRouter>
                <div className="home">
                    <div className="sidebar"><Sidebare /></div>
                    <div className="content">
                        <Route exact path="/" component={ListeEtudiants} />
                        <Route path="/inscription" component={NouveauEtudiant} />
                        <Route path="/reinscription" component={Reinscription} />
                        <Route path="/transfert" component={TransfertEtudiant} />
                        <Route path="/recherche" component={Recherche} />
                        <Route path="/certificat" component={CertificatScolarite} />
                        <Route path="/modifier/" component={ModifierEtudiant} />
                        <Route path="/absence/" component={Absence} />
                        <Route path="/gerer_utilisateurs/" component={GererUtilisateurs} />
                    </div>
                </div>
            </BrowserRouter>

        )
    }
}

export default Home